import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import TaskForm from '../../components/tasks/TaskForm';
import { FaArrowLeft, FaPlus } from 'react-icons/fa';
import projectService from '../../services/projectService';
import "../../styles/taskManagement.css";

const NewTaskPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [projectId, setProjectId] = useState(null);
  const [projectName, setProjectName] = useState('');
  const [loading, setLoading] = useState(false);
  
  // Extract projectId from query parameters if it exists
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const projectIdParam = searchParams.get('projectId');
    
    if (projectIdParam && projectIdParam !== 'undefined') {
      setProjectId(projectIdParam);
      setLoading(true);
      
      // Fetch project name for the header
      projectService.getProjectById(projectIdParam)
        .then(projectData => {
          if (projectData && projectData.name) {
            setProjectName(projectData.name);
          }
        })
        .catch(error => {
          console.error('Error fetching project details:', error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [location]);

  const handleSubmitSuccess = () => {
    // If we came from a project page, go back there
    if (projectId) {
      navigate(`/tasks/project/${projectId}`);
    } else {
      navigate('/tasks');
    }
  };

  return (
    <div className="task-container">
      <div className="task-content-wrapper">
        <div className="back-link-container">
          <Link 
            to={projectId ? `/tasks/project/${projectId}` : '/tasks'} 
            className="back-link"
          >
            <FaArrowLeft className="back-link-icon" /> 
            {projectId ? `Back to ${projectName || 'Project'} Tasks` : 'Back to Tasks'}
          </Link>
        </div>

        <div className="form-page-container">
          <div className="page-header">
            <div className="page-header-icon">
              <FaPlus />
            </div>
          </div>
          
          <TaskForm 
            onSubmitSuccess={handleSubmitSuccess} 
            initialProjectId={projectId} 
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default NewTaskPage;
